export const headerLinkStyles =
  "md:hover:bg-[#e5d6c3]/50 rounded-md transition-colors ease-in-out duration-200 text-primary-blue border-primary-blue px-2 py-1.5 md:p-2";

export const headerHamburgerButtonStyles =
  "relative flex flex-col justify-center -mr-2 ml-1";
